import React from 'react';
import ProjectPage from '../../components/projects/ProjectPage';
import theFrameData from '../../data/projects/theframe.js';

function TheFrame() {
  return <ProjectPage projectData={theFrameData} />;
}

export default TheFrame;
